export enum CurrentOS {
  Windows = 'Windows',
  Linux = 'Linux',
  MacOS = 'MacOS',
  iOS = 'iOS',
  Android = 'Android',
  Unknown = 'Unknown',
}
